<div class="row mt-5 justify-content-center">
    <div class="col-lg-8 col-md-10 col-sm-12">
        <div class="text-start">
            <h4 *ngIf="!showSuccess" class="text-primary mb-0">¿Olvidaste tu contraseña?</h4>
            <p *ngIf="!showSuccess" class="text-secondary mb-3">Ingresa tu correo electrónico para recuperar tu cuenta.</p>
        </div>
        <form #forgotPasswordForm="ngForm" class="user" novalidate (ngSubmit)="onSubmit(forgotPasswordForm)" *ngIf="!showSuccess">
            <label class="form-label">Correo</label>
            <div class="input-group mb-3">
                <span class="input-group-text"><i class="far fa-envelope"></i></span>
                <input class="form-control" [(ngModel)]="email" name="emailInput" #emailInput="ngModel" email type="email" [ngClass]="{'is-invalid': (!emailInput.valid && formTouched), 'is-valid': (emailInput.valid && formTouched)}" placeholder="Escribe tu correo electrónico"
                    autocomplete="off" required>
                <app-error class="invalid-feedback" [errors]="emailInput.errors"></app-error>
            </div>
            <div *ngIf="userNotFound">
                <div class="alert alert-warning">
                    No se encontro un usuario registrado con ese correo.
                </div>
            </div>
            <div class="d-grid text-center gap-2 mt-5">
                <button type="submit" [disabled]="formSubmitted" class="btn btn-primary py-3 btn-block">Confirmar</button>
                <a class="small" [routerLink]="['/login']">Atrás</a>
            </div>
        </form>
        <div *ngIf="showSuccess">
            <div class="row">
                <div class="col">
                    <h4 class="text-success">¡Listo!</h4>
                    <p class="text-primary">Recibirás un correo en unos momentos para crear una nueva contraseña.</p>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col text-center">
                    <a class="small" [routerLink]="['/login']">Atrás</a>
                </div>
            </div>
        </div>
    </div>
</div>